import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import Typography from '@mui/material/Typography';
import getTransformedDate from 'utils/getTransformedDate';
import { UserResponseViewModel } from 'types/user';

interface Props {
    item: ITableHeadCell;
    rowData: UserResponseViewModel;
}

export const UserListCell = ({ rowData: data, item }: Props) => {
    const field = data[item.field as keyof Omit<UserResponseViewModel, 'profilePicture'>];

    if (item.field === 'isActive') {
        return <Typography variant="body2">{field ? 'active' : '--'}</Typography>;
    }

    if (item.field === 'firstName') {
        return (
            <Typography variant="body2">
                {field} {data.lastName}
            </Typography>
        );
    }

    if (item.field === 'updatedDate') {
        return <Typography variant="body2">{getTransformedDate(field as string, 'MM/DD/YYYY') || '--'}</Typography>;
    }

    return (
        <Typography noWrap variant="body2">
            {field || '--'}
        </Typography>
    );
};
